import { defineStore } from 'pinia'
import { nextTick, ref } from 'vue'

export const useUiStore = defineStore('ui', () => {

  const drawer = ref(true)
  const team = ref<any>(null)
  const tracker = ref<any>(null)
  const infoDrawer = ref<any>({ open: false, title: "", subtitle: "", content: "" })
  const tooltip = ref<{ el: HTMLElement | null, tooltip: string, show: boolean }>({ el: null, tooltip: "", show: false })

  const teamReportsPage = ref<string | null>(null)
  const selectedReport = ref<any | null>(null)

  let timeout: number = -1
  const openTooptip = (e: MouseEvent, text: string) => {
    if (timeout >= 0) {
      clearTimeout(timeout)
      timeout = -1
    }
    tooltip.value = { el: e.currentTarget as HTMLElement, tooltip: text, show: false }

    timeout = setTimeout(() => tooltip.value.show = true, 0)
  }
  const closeTooltip = () => {
    tooltip.value.show = false
    if (timeout >= 0) {
      clearTimeout(timeout)
      timeout = -1
    }
    timeout = setTimeout(() => tooltip.value.el = null, 100)
  }

  return {
    drawer,
    infoDrawer,
    team,
    tracker,
    tooltip,
    teamReportsPage,
    selectedReport,
    openTooptip,
    closeTooltip
  }
})